import React, { useState } from "react";
import {
  AppBar,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Toolbar,
  IconButton,
  Typography,
  CircularProgress
} from "@material-ui/core";
import propTypes from "prop-types";

import clsx from "clsx";

import AddCircle from "@material-ui/icons/AddCircleOutline";
import MenuIcon from "@material-ui/icons/Menu";

import useStyles from "./stylesToolbar";
import useSaldosAPI from "../../hooks/useSaldosAPI";
import TabsSaldo from "./TabsSaldo";

const ToolbarUsuario = ({
  open = true,
  handleDrawerOpen,
  current,
  setPayed,
  payed
  // loadingSaldo = true
}) => {


  const classes = useStyles();
  const [{ data, isLoading }] = useSaldosAPI();
  const [openD, setOpenD] = useState(false);
  
 
  // useEffect(() => {
  //   fetchSaldo("toolbar");
  // }, [data.saldo]);
  const handleClose = () => {
    setOpenD(false);
  };

  return (
    <AppBar
      position="absolute"
      className={clsx(classes.appBar, open && classes.appBarShift)}
    >
      <Toolbar className={classes.toolbar}>
        <IconButton
          edge="start"
          color="inherit"
          aria-label="open drawer"
          onClick={() => handleDrawerOpen()}
          className={clsx(classes.menuButton, open && classes.menuButtonHidden)}
        >
          <MenuIcon />
        </IconButton>
        <Typography
          component="h1"
          variant="h6"
          color="inherit"
          noWrap
          className={classes.title}
        >
          {current}
        </Typography>
        {isLoading ? (
          <CircularProgress color="secondary" />
        ) : (
          <Typography
            component="h1"
            variant="h6"
            color="inherit"
            noWrap
            className={classes.saldo}
          >
            Saldo: ${Math.round(data.saldo * 100) / 100}
          </Typography>
        )}

        <IconButton
          onClick={() => setOpenD(true)}
          color="inherit"
          style={{ borderRadius: "10px" }}
        >
          <AddCircle />
        </IconButton>
        <Dialog open={openD} onClose={handleClose}  >
          <DialogTitle
            id="alert-dialog-slide-title"
            style={{ paddingBottom: 0 }}
          >
            {"Proceso de recarga de saldo"}
          </DialogTitle>
          <DialogContent>
            <TabsSaldo payed={payed}setPayed={setPayed}/>
          </DialogContent>
          <DialogActions>
            <Button variant="contained" color="primary" onClick={handleClose}>
              Aceptar
            </Button>
          </DialogActions>
        </Dialog>
      </Toolbar>
    </AppBar>
  );
};

ToolbarUsuario.propTypes = {
  open: propTypes.bool,
  handleDrawerOpen: propTypes.func,
  current: propTypes.string,
  loadingSaldo: propTypes.bool
};

export default ToolbarUsuario;
